import { createFileRoute } from "@tanstack/react-router";
import { GuideReviewPage } from "@/features/experiments/guide-review-page";

export const Route = createFileRoute("/guides/$id_/review")({
  validateSearch: (search: Record<string, unknown>) => ({
    reviewStep: typeof search.reviewStep === "string" ? search.reviewStep : undefined,
  }),
  component: Page,
});

function Page() {
  const { id } = Route.useParams();
  const { reviewStep } = Route.useSearch();
  return <GuideReviewPage id={id} initialStep={reviewStep} />;
}
